import React, { useEffect} from "react";
import { withTranslation } from "react-i18next";
import { Image, Divider, Button, Spin} from "antd";
import styled from "styled-components";
import { useState } from "react";
import { connect } from "react-redux";
import { push } from "connected-react-router";

// Redux
import { resetUiEnv } from 'modules/ui/actions';

// Utils
import { get } from "library/endpoints";

// Components
import Text from "components/Text";
import PaydByGiftCard from "../PaydByGiftCard";
import Title from "components/Title";
import PaypalPayment from "components/PaypalPayment";

// Styled
import * as Styled from '../../styled';

const StyledButtonLinkGiftCard = styled(Button)`
  color: #53b297;

  &:hover {
    color: #13a9c6 !important;
  }
`;

/**
 * Payment
 * @param {*} props 
 * @returns 
 */
const Payment = (props) => {
  const [displayGiftCard, setDisplayGiftCard] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('callback')) {
      if (urlParams.get('callback') === 'stancer') {
        checkStancerPayment(urlParams.get('basket'))
      }
    }
  }, []) // eslint-disable-line

  if (!props.paymentData) {
    props.setView('default');
  }

  const checkStancerPayment = async (basketId) => {
    try {
      setLoading(true)
      const { data } = await get(`/frontend/payment/check-stancer-status/${basketId}`);

      if (data.basket.paid === true) {
        props.resetUiEnv();
        setLoading(false)
        props.push('/orders/success')
      } else if (data.paymentInfos.status !== 'captured' && data.paymentInfos.status !== 'to_capture') {
        props.resetUiEnv();
        setLoading(false)
        props.push('/orders/fail')
      }
    } catch (error) {
      setLoading(false)
      console.log(error)
    }
  }


  const getTotalPrice = () => {
    let count =  props.paymentData.initial_amount + (props.paymentData.shipping_fees || 0);
    return count;
  }

  const getRemainingPrice = () => {
    return getTotalPrice() - props.paymentData.giftcard_amount;
  }

  // const handleOnPay = async () => {
  //   try {
  //     const { data } = await get(`/frontend/payment/${props.paymentData._id}`);
  //     window.location.href = data.url;
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const handleOnPayByStancer = async () => {
    try {
      const { data } = await get(`/frontend/payment/stancer/${props.paymentData._id}`);
      if (data.checkout.url) {
        window.location.href = data.checkout.url;
      }
    } catch (error) {
      console.log(error)
    }
  }

  const getCountryName = () => {
    const country = props.countries.find((country) => country._id.toString() === props.paymentData.delivery.country.toString())
    
    if (country) {
      return country
    }

    return {
      name : {
        fr: '',
        en: '',
      }
    }
  }

  if (loading) {
    return (
      <div>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
          <Spin />
        </div>
        <Text align="center">Traitement de votre commande en cours, veuillez patienter</Text>

      </div>
    )
  }


  return (
    <>
      <Styled.OptionsSelector
        onClick={() => props.setView('delivery')}      
      >
        <Title style={{ marginBottom: 20, marginTop: -2 }} size={18}>Paiement</Title>
      </Styled.OptionsSelector>

        <Text align="center" style={{ marginTop: 20 }} size={14}>Récapitulatif de votre commande</Text>
        <Divider />

        {
          props.paymentData && (
            <>
              <div style={{ width: '90%', maxWidth: 500, margin: 'auto', marginTop: 20 }}>
                {
                  props.paymentData.products.map((item) => (
                    <>
                      <div style={{ display: 'flex' }}>
                        <Image src={`${process.env.REACT_APP_S3_FILES_URL}${item.mount.output}`} width={150} />

                        <div>

                        <Text size={14} style={{ marginLeft: 10, marginTop: 0, marginBottom: 10  }}>{`${item.support.parentSupport.name_fr || item.support.parentSupport._provider_name} ${item.support.name}`}</Text>

                        {
                          item.options.length > 0 && (
                            <div style={{ marginLeft: 10 }}>
                              {
                                item.options.filter((category) => category.selectedOption !== null).length > 0 && (
                                  <>
                                    <Text size={14} color="grey" style={{ borderBottom: '1px dashed lightgrey', paddingBottom: 5 }}>Options sélectionnées</Text>
                                    {
                                      item.options.filter((category) => category.selectedOption !== null).map((category) => (
                                        <div style={{ marginLeft: 10, display: 'flex', paddingTop: 5 }}>
                                          <Text color="grey" size={12}>{`${category.selectableOptionName} - ${category.selectedOption.name}`}</Text>
                                        </div>
                                      ))
                                    }
                                  </>
                                )
                              }
                            </div>
                          )
                        }
                        </div>
                      </div>
                      <Divider style={{ margin: 10 }} />
                    </>
                  ))
                }

                <div style={{ display: 'flex', marginBottom: 20, marginTop: 20 }}>
                  <Text size={14}>Frais de port</Text>
                  <Text size={14} style={{ marginLeft: 'auto' }} >{props.paymentData.shipping_fees || 0}€</Text>
                </div>

                <Divider style={{ margin: 10 }} />
                
                <div style={{ display: 'flex', marginBottom: 20, marginTop: 20 }}>
                  <Text size={16}>Montant total TTC</Text>
                  <Text size={16} style={{ marginLeft: 'auto' }} color="#176b87" >{getTotalPrice().toFixed(2)}€</Text>
                </div>
                
                {
                  props.paymentData.giftcard_amount && props.paymentData.giftcard_amount > 0 && (
                    <>
                      <div style={{ display: 'flex', marginBottom: 20, marginTop: 20 }}>
                        <Text size={16}>Payé par carte cadeau : </Text>
                        <Text size={16} style={{ marginLeft: 'auto' }} color="#53b6ba" >{props.paymentData.giftcard_amount}€</Text>
                      </div>

                      <div style={{ display: 'flex', marginBottom: 20, marginTop: 20 }}>
                        <Text size={16}>Restant dû : </Text>
                        <Text size={16} style={{ marginLeft: 'auto' }} color="#53b6ba" >{getRemainingPrice().toFixed(2)}€</Text>
                      </div>
                    </>
                  )
                }

                <Divider style={{ margin: 10 }} />

                <div style={{ marginBottom: 20, marginTop: 20 }}>
                  <Text size={16} style={{ marginBottom: 10 }}>Adresse de livraison</Text>
                  <Text size={14} style={{ marginBottom: 5 }}>{props.paymentData.delivery.firstname} {props.paymentData.delivery.lastname}</Text>
                  <Text size={14} style={{ marginBottom: 5 }}>{props.paymentData.delivery.company}</Text>               
                  <Text size={14} style={{ marginBottom: 5 }}>{props.paymentData.delivery.address}</Text> 
                  <Text size={14} style={{ marginBottom: 5 }}>{props.paymentData.delivery.postcode} {props.paymentData.delivery.city} {getCountryName().name.fr}</Text>
                </div>
                <Divider style={{ margin: 10 }} />

                <Button onClick={() => handleOnPayByStancer()} type="primary" style={{ width: '100%'}}>Payer par carte</Button>
                
                <div style={{ marginBottom: 10 }} />
                
                <PaypalPayment 
                  basket={props.paymentData}
                />

                {
                  !props.paymentData.giftcard_amount && (
                    <StyledButtonLinkGiftCard type="link" onClick={() => setDisplayGiftCard(true)}>J'ai une carte cadeau</StyledButtonLinkGiftCard>
                  )
                }
                
                {
                  !props.paymentData.giftcard_amount && displayGiftCard && (
                    <PaydByGiftCard
                      basket={props.paymentData}
                      handleRefreshPaymentData={props.setPaymentData}
                      setDisplayGiftCard={setDisplayGiftCard} 
                      totalPrice={getTotalPrice()}
                      setPaymentData={props.setPaymentData}
                    />
                  )
                }
              </div>
            </>
          )
        }
    </>
  )
}

const dispatchToProps = {
  push,
  resetUiEnv
}

export default connect(null, dispatchToProps)(withTranslation()(Payment));